export class ScrollFire {
  constructor({
    targetSelector,
    className,
    onEnter = () => {},
    onExit = () => {},
    root = null,
    rootMargin = '0px',
    threshold = 1.0,
  }) {
    this.targetElements = document.querySelectorAll(targetSelector);
    this.className = className;
    this.onEnter = onEnter;
    this.onExit = onExit;
    this.init(root, rootMargin, threshold);
  }

  init(root, rootMargin, threshold) {
    const observerOptions = {
      root,
      rootMargin,
      threshold,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) { // if target is completely invisible
          entry.target.classList.remove(this.className); // remove class
          this.onExit(entry.target); // call onExit callback
        } else {
          entry.target.classList.add(this.className); // add class
          this.onEnter(entry.target); // call onEnter callback
        }
      });
    }, observerOptions);

    this.targetElements.forEach((element) => {
      observer.observe(element);
    });
  }
}
